{
  "name": "@iocium/throwaway-lookup",
  "version": "1.0.1",
  "description": "Cross-platform client for throwaway.cloud API",
  "main": "dist/index.js",
  "module": "./dist/index.mjs",
  "browser": "./dist/index.global.js",
  "types": "dist/index.d.ts",
  "exports": {
    ".": {
      "import": "./dist/index.js",
      "require": "./dist/index.cjs",
      "types": "./dist/index.d.ts"
    }
  },
  "scripts": {
    "build": "tsc",
    "build:tsup": "tsup",
    "test": "jest",
    "test:coverage": "jest --coverage",
    "docs": "typedoc"
  },
  "type": "module",
  "keywords": [
    "disposable",
    "email",
    "lookup",
    "cloudflare",
    "browser",
    "node"
  ],
  "author": "Iocium",
  "license": "MIT",
  "devDependencies": {
    "@types/jest": "^29.5.14",
    "auto-changelog": "^2.5.0",
    "jest": "^29.0.0",
    "ts-jest": "^29.0.0",
    "tsup": "^8.4.0",
    "typedoc": "^0.28.4",
    "typescript": "^5.8.3"
  }
}
